import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { MergeResult } from '../../domain/domain';
import { MergeFailure } from '../../domain/domain';
import MUIDataTable from 'mui-datatables';

type Props = {
    open: boolean,
    mergeResult: MergeResult,
    onClose: () => void
}

type MergeFailuresTableProps = {
    mergeFailures: MergeFailure[]
}

const MergeFailuresTable : React.FC<MergeFailuresTableProps> = ({mergeFailures}) => {
    const columns = [
        {
            name: 'billNum',
            label: 'Bill No'
        },
        {
            name: 'billSection',
            label: 'Bill Section'
        },
        {
            name: 'citation',
            label: 'Citation'
        },
        {
            name: 'action',
            label: 'Change Type'
        },
        {
            name: 'errorMsg',
            label: 'Message'
        },
    ]

    return (
        <MUIDataTable
            title=""
            columns={columns}
            data={mergeFailures}
            options={{
                filter: false,
                search: false,
                print: false,
                download: false,
                viewColumns: false,
                selectableRows: undefined,
                sortOrder: {
                    name: 'titleNumber',
                    direction: 'asc'
                },
                rowsPerPage: 20,
                elevation: 0,
                setTableProps: () => {
                    return {
                        size: "small",
                        padding: "1px"
                    }
                }
            }}></MUIDataTable>
    )
}

const MergeResultDialog : React.FC<Props> = ({open, onClose, mergeResult}) => {
    const liveRegionRef = useRef<HTMLDivElement>(null);
    const [liveRegionMessage, setLiveRegionMessage] = useState<string>('');

    useEffect(() => {
        if (open) {
            setLiveRegionMessage('');
            setTimeout(() => {
                const recordsUpdatedCount = mergeResult.recordsUpdated;
                const recordsUpdatedPlural = recordsUpdatedCount === 1 ? 'record' : 'records';
                const failedToMergeCount = mergeResult.failToMergeRecords.length;
                const failedToMergePlural = failedToMergeCount === 1 ? 'record' : 'records';

                const successMessage = `Merge completed. ${recordsUpdatedCount} ${recordsUpdatedPlural} merged successfully and ${failedToMergeCount} ${failedToMergePlural} failed to merge.`;
                setLiveRegionMessage(successMessage);
            }, 100);
        }
    }, [open, mergeResult]);

    return (
        <Dialog open={open} maxWidth='lg'>
            <div
                ref={liveRegionRef}
                aria-live="assertive"
                aria-atomic="true"
                className={'visually-hidden'}
            >
                {liveRegionMessage}
            </div>
            <DialogTitle>
                Merge completed
            </DialogTitle>
            <DialogContent>
                <Grid container direction='column' className="flex-gap-1">
                    <Grid item>
                        <Typography variant='body2'>{mergeResult.recordsUpdated} records merged successfully.</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant='body2' color='error'>{mergeResult.failToMergeRecords.length} records failed to merge:</Typography>
                    </Grid>
                    {mergeResult.failToMergeRecords.length > 0 &&
                        <Grid item>
                            <MergeFailuresTable mergeFailures={mergeResult.failToMergeRecords} />
                        </Grid>
                    }
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant='contained' color='primary' onClick={() => {
                    onClose();
                }}>Close</Button>
            </DialogActions>
        </Dialog>
    )
}

export default MergeResultDialog;